import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { getUserDetails } from "../../utils/Util";
import "../rentaroomstyle.css";

const NAV_LINKS = [
  { to: "/rentaroom/dashboard",  label: "Dashboard",   icon: "bi-grid-fill",       exact: true },
  { to: "/rentaroom/talepler",   label: "Talepler",    icon: "bi-inbox-fill" },
  { to: "/rentaroom/siparisler", label: "Siparişler",  icon: "bi-bag-check-fill" },
];

interface Props {
  collapsed: boolean;
  onToggle: () => void;
  isMobile: boolean;
  drawerOpen: boolean;
  onDrawerClose: () => void;
}

export default function RentARoomSidebar({ collapsed, onToggle, isMobile, drawerOpen, onDrawerClose }: Props) {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");

  React.useEffect(() => {
    getUserDetails().then((u) => {
      if (u) setUserName(`${u.customerName} ${u.customerSurName}`.trim());
    });
  }, []);

  const fncLogout = () => {
    localStorage.removeItem("user");
    navigate("/rentaroom", { replace: true });
  };

  const initials = userName.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2);

  /* ── MOBILE: slide-in drawer ── */
  if (isMobile) {
    return (
      <>
        {drawerOpen && (
          <div className="rar-drawer-backdrop" onClick={onDrawerClose} />
        )}

        <aside className={`rar-drawer ${drawerOpen ? "open" : "closed"}`}>
          <div className="rar-drawer-header">
            <div className="rar-drawer-brand">
              <div className="rar-drawer-brand-icon">
                <i className="bi bi-building text-white" style={{ fontSize: "1.1rem" }}></i>
              </div>
              <span className="rar-drawer-brand-label">RentARoom</span>
            </div>
            <button className="rar-drawer-close-btn" onClick={onDrawerClose}>
              <i className="bi bi-x-lg" style={{ fontSize: "0.85rem" }}></i>
            </button>
          </div>

          <nav className="rar-drawer-nav">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.exact}
                onClick={onDrawerClose}
                className={({ isActive }) => `rar-drawer-link ${isActive ? "active" : "inactive"}`}
              >
                <i className={`bi ${l.icon}`} style={{ fontSize: "1.2rem", flexShrink: 0 }}></i>
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="rar-drawer-footer">
            {userName && (
              <div className="rar-drawer-user">
                <div className="rar-drawer-avatar">{initials}</div>
                <span className="rar-drawer-username">{userName}</span>
              </div>
            )}
            <button className="rar-drawer-logout-btn" onClick={fncLogout}>
              <i className="bi bi-box-arrow-right" style={{ fontSize: "1.1rem" }}></i>
              Çıkış Yap
            </button>
          </div>
        </aside>
      </>
    );
  }

  /* ── DESKTOP: collapsible sticky sidebar ── */
  return (
    <aside
      className="rar-sidebar"
      style={{ width: collapsed ? "64px" : "220px" }}
    >
      <div
        className="rar-sidebar-brand"
        style={{
          justifyContent: collapsed ? "center" : "space-between",
          padding: collapsed ? "20px 0" : "20px 16px",
        }}
      >
        {!collapsed && (
          <div className="rar-sidebar-brand-inner">
            <div className="rar-sidebar-brand-icon">
              <i className="bi bi-building text-white" style={{ fontSize: "1rem" }}></i>
            </div>
            <span className="rar-sidebar-brand-label">RentARoom</span>
          </div>
        )}
        <button className="rar-sidebar-toggle-btn" onClick={onToggle}>
          <i className={`bi ${collapsed ? "bi-chevron-right" : "bi-chevron-left"}`} style={{ fontSize: "0.75rem" }}></i>
        </button>
      </div>

      <nav className="rar-sidebar-nav">
        {NAV_LINKS.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.exact}
            className={({ isActive }) => `rar-sidebar-link ${isActive ? "active" : "inactive"}`}
            style={{
              gap: collapsed ? 0 : 10,
              justifyContent: collapsed ? "center" : "flex-start",
              padding: collapsed ? "10px 0" : "10px 12px",
            }}
          >
            <i className={`bi ${l.icon}`} style={{ fontSize: "1.1rem", flexShrink: 0 }}></i>
            {!collapsed && l.label}
          </NavLink>
        ))}
      </nav>

      <div
        className="rar-sidebar-footer"
        style={{ padding: collapsed ? "12px 0" : "12px 8px" }}
      >
        {!collapsed && userName && (
          <div className="rar-sidebar-user">
            <div className="rar-sidebar-avatar">{initials}</div>
            <span className="rar-sidebar-username">{userName}</span>
          </div>
        )}
        <button
          className="rar-sidebar-logout-btn"
          style={{
            justifyContent: collapsed ? "center" : "flex-start",
            gap: collapsed ? 0 : 8,
            padding: collapsed ? "10px 0" : "10px 12px",
          }}
          onClick={fncLogout}
        >
          <i className="bi bi-box-arrow-right" style={{ fontSize: "1rem", flexShrink: 0 }}></i>
          {!collapsed && "Çıkış Yap"}
        </button>
      </div>
    </aside>
  );
}
